import React from 'react';
import { Row, Col, Icon } from 'antd';
import ArrowLink from 'components/ArrowLink';
import { useTranslation } from 'react-i18next';

export default function MetQualifiedSafeBlock() {
  const { t } = useTranslation()
  return (
    <>
      <div
        style={{
          height: '400px',
          backgroundColor: '#F9F9F9',
          paddingTop: '150px'
        }}
      >
        <Row type="flex" justify="center" align="top">
          <Col lg={6} xs={18}>
            <Icon type="search" />
            <h3>{t('Met')}</h3>
            <p>{t('We interview and screen all of our tutors')}</p>
            <ArrowLink linkUrl={'#'} text={t("Read More")} />
          </Col>
          <Col lg={6} xs={18}>
            <Icon type="search" />
            <h3>{t('Qualified')}</h3>
            <p>{t('All of our tutors are educated to degree level')}</p>
            <ArrowLink linkUrl={'#'} text={t("Read More")} />
          </Col>
          <Col lg={6} xs={18}>
            <Icon type="search" />
            <h3>{t('Safe')}</h3>
            <p>{t('Every one of our tutors has an up-to-date DBS check')}</p>
            <ArrowLink linkUrl={'#'} text={t("Read More")} />
          </Col>
        </Row>
      </div>
    </>
  );
}
